module.exports = __webpack_public_path__ + "img/106@3x.a94eb13d.png";